var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-main',{attrs:{"categories":_vm.categories}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_vm._v(" "),_c('footer-main',{attrs:{"categories":_vm.categories}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }